import React from "react";

const Header = (props) => (
    <h1 style={Object.assign({}, {
        color: "#28313E",
        fontWeight: "bold",
        margin: 0,
        padding: 10,
        fontSize: "1em",
        borderBottom: "1px solid #ddd",
        backgroundColor: "#eee"}, props.style || {})} >{props.children}</h1>
);

export default Header;


/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/components/Header.js
 **/